import * as React from 'react';

import type { WosIconProps } from 'types/common_types';

function arrangements(props: WosIconProps) {
  const { className } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 721.1 722.5"
      fill="currentColor"
      className={className}
    >
      <path d="M309.46,432.97H28.46c-14.1,0-25.55-10.71-25.55-23.91V26.58C2.91,13.38,14.36,2.67,28.46,2.67H309.46c14.1,0,25.55,10.71,25.55,23.91V409.06c0,13.2-11.44,23.91-25.55,23.91Z" />
      <path d="M309.46,719.83H28.46c-14.1,0-25.55-10.71-25.55-23.91v-191.24c0-13.2,11.44-23.91,25.55-23.91H309.46c14.1,0,25.55,10.71,25.55,23.91v191.24c0,13.2-11.44,23.91-25.55,23.91Z" />
      <path d="M692.64,241.72H411.64c-14.1,0-25.55-10.71-25.55-23.91V26.58c0-13.2,11.44-23.91,25.55-23.91h281c14.1,0,25.55,10.71,25.55,23.91V217.82c0,13.2-11.44,23.91-25.55,23.91Z" />
      <path d="M692.64,719.83H411.64c-14.1,0-25.55-10.71-25.55-23.91V313.44c0-13.2,11.44-23.91,25.55-23.91h281c14.1,0,25.55,10.71,25.55,23.91v382.49c0,13.2-11.44,23.91-25.55,23.91Z" />
    </svg>
  );
}

export default arrangements;
